/**
 * 发布应用实体组件
 * zxw
 * 创建时间 2026-04-17
 */

import CNF from '../../incs/Config';
import {
    locale,
    AddRequestHeaders,
} from '../../incs/FunHelper';

import { useState, useEffect } from 'react';
import $ from 'jquery';
import {
    ConfigProvider,
    Modal,
    Space,
    Typography,
    Input,
    message,
    Select,
    Radio,
} from 'antd';

const { Text, } = Typography;
const { TextArea } = Input;

const MODULENAME_URL = '/app/infos';

const AppReleaseEntity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [appFiled, setAppFiled] = useState('');             // 应用领域
    const [appTags, setAppTags] = useState('');               // 应用标签
    const [promptTitle, setPromptTitle] = useState('');       // 提示标题
    const [promptExamples, setPromptExamples] = useState(''); // 提示样例
    const [isInput, setIsInput] = useState(1);                // 是否输入


    useEffect(() => {
        setOpen(props.open);
        setAppFiled(props.record.app_filed);
        setAppTags(props.record.app_tags);
        setPromptTitle(props.record.prompt_title);
        setPromptExamples(props.record.prompt_examples);
        setIsInput(props.record.is_input);
    }, [props]);

    const cancel = () => {
        setOpen(false);
    }

    const ok = () => {
        //  参数校验
        if (appFiled === '') {
            messageApi.error('应用领域不能为空！');
            return;
        }
        if (appTags === '') {
            messageApi.error('应用标签不能为空！');
            return;
        }
        if (promptTitle === '') {
            messageApi.error('提示标题不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1,)}/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'app_filed': appFiled,
                'app_tags': appTags,
                'prompt_title': promptTitle,
                'prompt_examples': promptExamples,
                'is_input': isInput,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    setLoading(false);
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }


    return <ConfigProvider
        locale={locale}
        theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
        {contextHolder}
        <Modal
            title={<span style={{ color: CNF.colorBaseText }}>发布应用-{props.record?.app_name}</span>}
            mask={{ blur: false }}
            width={600}
            open={open}
            onOk={ok}
            onCancel={cancel}
            okButtonProps={{ loading }}
            style={{
                top: CNF.menuHeight,
            }}
            styles={{
                container: {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
                header: {
                    paddingLeft: CNF.basePadding,
                    paddingBottom: 14,
                    borderBottom: `1px solid ${CNF.colorBaseBorderSolid}`,
                    marginBottom: 0,
                },
                footer: {
                    borderTop: `1px solid ${CNF.colorBaseBorderSolid}`,
                    marginTop: 0,
                    paddingRight: CNF.basePadding,
                    paddingTop: CNF.basePadding,
                }
            }}
        >

            {/* 内容部分 */}
            <Space orientation='vertical' size='middle' style={{ width: '100%', padding: CNF.basePadding, }}>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>应用领域<Text type='danger'>*</Text></Text>
                    <Select
                        style={{ width: `calc(100% - ${CNF.basePadding * 2}px)`, color: CNF.colorBaseText }}
                        placeholder='请选择应用领域'
                        options={CNF.appFileds.map(item => {
                            return {
                                label: item.label,
                                value: item.value,
                            };
                        })}
                        value={appFiled ? appFiled : undefined}
                        onChange={(value) => setAppFiled(value)}
                    />
                </div>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>应用标签<Text type='danger'>*</Text></Text>
                    <Input
                        style={{ width: `calc(100% - ${CNF.basePadding * 2}px)`, color: CNF.colorBaseText }}
                        placeholder='请输入应用标签，多个标签用“|”隔开。'
                        value={appTags}
                        onChange={(e) => setAppTags(e.target.value)}
                    />
                </div>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>提示标题<Text type='danger'>*</Text></Text>
                    <TextArea
                        style={{ width: `calc(100% - ${CNF.basePadding * 2}px)`, color: CNF.colorBaseText }}
                        placeholder='请输入提示标题'
                        autoSize={{ minRows: 3, maxRows: 4 }}
                        value={promptTitle}
                        onChange={(e) => setPromptTitle(e.target.value)}
                    />
                </div>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>提示示例</Text>
                    <TextArea
                        style={{ width: `calc(100% - ${CNF.basePadding * 2}px)`, color: CNF.colorBaseText }}
                        placeholder='请输入提示示例，多个示例用“|”隔开。'
                        autoSize={{ minRows: 3, maxRows: 4 }}
                        value={promptExamples}
                        onChange={(e) => setPromptExamples(e.target.value)}
                    />
                </div>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>是否需要输入：</Text>
                    <Radio.Group
                        options={[
                            { value: 0, label: '否' },
                            { value: 1, label: '是' },
                        ]}
                        value={isInput}
                        onChange={(e) => {
                            setIsInput(e.target.value);
                        }}
                    />
                </div>
            </Space>
        </Modal >
    </ConfigProvider>
}

export default AppReleaseEntity